module.exports = __webpack_public_path__ + "img/arefev.8a9616ce.jpg";